import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchClients, fetchStatistic, searchClients } from 'store/superadmin/superadminOperations';
import { statisticBlocksMapping } from './constants';
import Typography from '@material-ui/core/Typography';
import { SearchSelect } from 'lib';
import MonthPicker from './components/MonthPicker/MonthPicker';
import StatisticBlock from './components/StatisticCard/StatisticBlock';

import './styles.scss';

const ALL_COMPANIES = { _id: 'All', name: 'All Companies' };

const Home = () => {
  const [selectedClient, setSelectedClient] = useState(ALL_COMPANIES._id);
  const [month, setMonth] = useState(new Date());
  const statistic = useSelector((state) => state.superadmin.statistic);
  const statisticArray = useMemo(() => {
    return statisticBlocksMapping.map(({ name, field, active }) => ({
      text: name,
      quantity: +(statistic?.[field]?.curr?.toFixed(2)) || (active ? 0 : 'N/A'),
      diff: +((statistic?.[field]?.curr || 0) - (statistic?.[field]?.prev || 0)).toFixed(2),
      active: active,
    }))
  }, [statistic])

  const dispatch = useDispatch();

  // Home no longer reads the clients list, but the Users page's AssignToClient still does
  useEffect(() => {
    dispatch(fetchClients());
  }, []);

  useEffect(() => {
    dispatch(fetchStatistic(month, selectedClient));
  }, [month, selectedClient])


  return (
    <>
      <div>
        <Typography variant="h3" style={{marginBottom: '20px'}}>
          Statistics
        </Typography>
        <div className={'statistic-month-picker-wrapper'}>
          <MonthPicker onChange={setMonth} />

          <label htmlFor="companies" style={{width: '255px'}}>
            <SearchSelect
              value={selectedClient}
              onChange={setSelectedClient}
              options={[ALL_COMPANIES]}
              loadOptions={searchClients}
              inputProps={{ id: 'companies', name: 'companies', 'aria-label': 'companies' }}
            />
          </label>
        </div>
      </div>
      <div className={'statistic-card-home-wrapper'}>
        {statisticArray.map((el, index) => (
          <StatisticBlock key={index} quantity={el.quantity} text={el.text} diff={el.diff} active={el.active} />
        ))}
      </div>
    </>
  );
};

export default Home;
